import { type ComponentPropsWithRef, type ReactNode } from 'react'

import { LinkHash, LinkOutbound, LinkRoute } from '@/components/common/Link'
import { type DistributiveOmit } from '@/defs/misc'

export type Props = {
  children?: ReactNode
} & (
  | ({ as?: 'button' } & DistributiveOmit<ComponentPropsWithRef<'button'>, 'children'>)
  | ({ as: 'div' } & DistributiveOmit<ComponentPropsWithRef<'div'>, 'children'>)
  | ({ as: 'span' } & DistributiveOmit<ComponentPropsWithRef<'span'>, 'children'>)
  | ({ as: 'a' } & DistributiveOmit<ComponentPropsWithRef<'a'>, 'children'>)
  | ({ as: 'LinkHash' } & DistributiveOmit<ComponentPropsWithRef<typeof LinkHash>, 'children'>)
  | ({ as: 'LinkRoute' } & DistributiveOmit<ComponentPropsWithRef<typeof LinkRoute>, 'children'>)
  | ({ as: 'LinkOutbound' } & DistributiveOmit<ComponentPropsWithRef<typeof LinkOutbound>, 'children'>)
)

export const ButtonRoot = (props: Props) => {
  switch (props.as) {
    case 'div': {
      const { as: _, children, ...propsElement } = props
      return <div {...propsElement}>{children}</div>
    }
    case 'span': {
      const { as: _, children, ...propsElement } = props
      return <span {...propsElement}>{children}</span>
    }
    case 'a': {
      const { as: _, children, ...propsElement } = props
      return <a {...propsElement}>{children}</a>
    }
    case 'LinkHash': {
      const { as: _, children, ...propsElement } = props
      return <LinkHash {...propsElement}>{children}</LinkHash>
    }
    case 'LinkRoute': {
      const { as: _, children, ...propsElement } = props
      return <LinkRoute {...propsElement}>{children}</LinkRoute>
    }
    case 'LinkOutbound': {
      const { as: _, children, ...propsElement } = props
      return <LinkOutbound {...propsElement}>{children}</LinkOutbound>
    }
    case 'button':
    default: {
      const { as: _, children, disabled, onClick, type = 'button', ...propsElement } = props
      return (
        <button
          aria-disabled={disabled || undefined}
          disabled={disabled && type === 'submit' ? true : undefined}
          onClick={disabled ? undefined : onClick}
          type={type}
          {...propsElement}
        >
          {children}
        </button>
      )
    }
  }
}
